function loadScriptAsync(scriptSrc, callback) {
  if (typeof callback !== "function") {
    throw new Error("Not a valid callback for async script load");
  }
  var script = document.createElement("script");
  script.onload = callback;
  script.src = scriptSrc;
  document.head.appendChild(script);
}

/* This is the part where you call the above defined function and "call back" your code which gets executed after the script has loaded */

export function googleAnalyticsScript() {
  loadScriptAsync(
    "https://www.googletagmanager.com/gtag/js?id=G-YE4E4L3BGJ",
    function () {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-YE4E4L3BGJ");
    },
  );
}

export const googleTagManagerScript = (
  gtmId = "GTM-MCDJTP9B",
  dataLayerName = "dataLayer",
) => {
  if (typeof window === "undefined") return;

  window[dataLayerName] = window[dataLayerName] || [];
  window[dataLayerName].push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const firstScript = document.getElementsByTagName("script")[0];
  const gtmScript = document.createElement("script");
  const dlParam = dataLayerName !== "dataLayer" ? `&l=${dataLayerName}` : "";

  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}${dlParam}`;

  firstScript.parentNode.insertBefore(gtmScript, firstScript);
};
